import { createStyles }     from "@mantine/core";
import { rooterMediaQuery } from "_styles/theme/mediaQuery";

export default createStyles ( ( theme, props ) => ( {
	mainMenuContainer: {
		// backgroundColor    : theme.other.colors.background.secondary,
		"& .MuiPaper-root": {
			background   : theme.other.darkMode ? theme.other.paletteNew.darkModeInclinedBlack2 : theme.other.paletteNew.secondaryWhite,
			borderRadius : "1rem"
		},
		"& .listContainer": {
			padding: "0",

			"& li": {
				padding      : "0.5rem 1.5rem",
				marginBottom : "0.5rem"
			}
		}
	},
	dropdown: {
		border   : `1px solid ${ theme.other.colors.border.primary }`,
		padding  : "0",
		overflow : "hidden"

	},
	notificationPageWrapper: {
		borderRadius: "1rem"
	},
	notificationBackgroundWrapper: {
		// padding         : "1rem 0",
		// display         : "flex",
		// alignItems      : "center",
		// justifyContent  : "space-between",
		// backgroundColor : theme.other.darkMode ? theme.other.paletteNew.darkModeInclinedBlack2 : theme.other.paletteNew.secondaryWhite,
		// maxWidth        : "500px",
		maxHeight     : "80vh",
		margin        : props?.isNotificationsPage ? "2rem auto" : "unset",
		width         : "100%",
		display       : "flex",
		flexDirection : "column",
		minHeight     : "80vh",
		minWidth      : props?.isNotificationsPage ? "40vw" : "30vw",
		maxWidth      : props?.isNotificationsPage ? "45vw" : "35vh",
		overflow      : "hidden",
		borderRadius  : props?.isNotificationsPage ? "1rem" : "unset",
		...( props?.isNotificationsPage && !theme.other.darkMode && { border: `1px solid ${ theme.other.colors.border.primary }` } ),

		[rooterMediaQuery.mobile]: {
			maxWidth     : "unset",
			minWidth     : "unset",
			margin       : "unset",
			borderRadius : "unset",
			minHeight    : "unset",
			maxHeight    : "unset"
		}

	},
	notificationBackgroundWrapperSettings: {
		// alignItems      : "center",
		// justifyContent  : "space-between",
		backgroundColor : theme.other.darkMode ? theme.other.paletteNew.darkModeInclinedBlack2 : theme.other.paletteNew.secondaryWhite,
		// maxWidth        : "500px",
		margin          : props?.isNotificationsPage ? "2rem auto" : "unset",
		width           : "100%",
		minHeight       : "80vh",
		maxHeight       : "95vh",
		minWidth        : props?.isNotificationsPage ? "40vw" : "30vw",
		maxWidth        : props?.isNotificationsPage ? "45vw" : "35vh",
		overflow        : "hidden",
		borderRadius    : props?.isNotificationsPage ? "1rem" : "unset",

		[rooterMediaQuery.mobile]: {
			minHeight    : "unset",
			maxHeight    : "unset",
			borderRadius : "unset",
			minWidth     : "unset",
			maxWidth     : "unset",
			margin       : "unset"
		}
	},
	notificationTopSection: {
		width      : "100%",
		paddingTop : "1rem"
	},
	notificationHeaderAndSettings: {
		width          : "100%",
		padding        : "1rem 2rem",
		display        : "flex",
		justifyContent : "space-between"
	},
	settingsText: {
		fontWeight : "500",
		fontSize   : "2rem"
	},
	backIcon: {
		height      : "3rem",
		width       : "3rem",
		marginRight : "1rem"
	},
	headerTextContainer: {
		display        : "flex",
		justifyContent : "center",
		alignItems     : "center"
	}
} ) );

